import { render, staticRenderFns } from "./suggestionVendor.vue?vue&type=template&id=9e5e37a4"
import script from "./suggestionVendor.vue?vue&type=script&lang=js"
export * from "./suggestionVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e5e37a4')) {
      api.createRecord('9e5e37a4', component.options)
    } else {
      api.reload('9e5e37a4', component.options)
    }
    module.hot.accept("./suggestionVendor.vue?vue&type=template&id=9e5e37a4", function () {
      api.rerender('9e5e37a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sug/suggestionVendor.vue"
export default component.exports